import { Building } from "../types";

export const buildings: Building[] = [
  {
    id: 1,
    name: "Franklin Garner",
    address: "920 Meadow Street, Imperial, California, 1930",
    floors: [
      {
        id: 0,
        name: "Dyer Blackwell",
      },
      {
        id: 1,
        name: "Dyer Blackwell",
      },
      {
        id: 2,
        name: "Dyer Blackwell",
      },
    ],
    offices: [
      {
        id: 0,
        name: "Cochran Conner",
      },
      {
        id: 1,
        name: "Blanche Mason",
      },
    ],
    rooms: [
      {
        id: 0,
        name: "Jewel Mccarthy",
      },
      {
        id: 1,
        name: "Soto Long",
      },
      {
        id: 2,
        name: "Lara Mckenzie",
      },
      {
        id: 3,
        name: "Casandra Nielsen",
      },
    ],
    devices: [
      {
        id: 0,
        name: "Brewer Rojas",
      },
      {
        id: 1,
        name: "Hampton Blackburn",
      },
      {
        id: 2,
        name: "Marian Carrillo",
      },
    ],
    onlineDevices: [
      {
        id: 0,
        name: "Watts Leonard",
      },
    ],
  },
  {
    id: 2,
    name: "Elisabeth Dominguez",
    address: "898 Rapelye Street, Wauhillau, Northern Mariana Islands, 5985",
    floors: [
      {
        id: 0,
        name: "Nielsen Burris",
      },
    ],
    offices: [
      {
        id: 0,
        name: "Aurora Marquez",
      },
    ],
    rooms: [
      {
        id: 0,
        name: "Vance Puckett",
      },
      {
        id: 1,
        name: "Aisha Horton",
      },
      {
        id: 2,
        name: "Gwen Hamilton",
      },
      {
        id: 3,
        name: "Talley Bridges",
      },
    ],
    devices: [
      {
        id: 0,
        name: "Abigail Sexton",
      },
      {
        id: 1,
        name: "Jodie Mcgowan",
      },
      {
        id: 2,
        name: "Tabitha Calderon",
      },
    ],
    onlineDevices: [
      {
        id: 0,
        name: "Maureen Cameron",
      },
      {
        id: 1,
        name: "Maureen Cameron",
      },
    ],
  },
  {
    id: 3,
    name: "Luna Maldonado",
    address: "886 Banker Street, Williston, Texas, 6298",
    floors: [
      {
        id: 0,
        name: "Robbie Lynn",
      },
    ],
    offices: [
      {
        id: 0,
        name: "Dunn Hines",
      },
      {
        id: 1,
        name: "Brittney Hudson",
      },
    ],
    rooms: [
      {
        id: 0,
        name: "Williamson Salas",
      },
      {
        id: 1,
        name: "Herring Mooney",
      },
      {
        id: 2,
        name: "Patrica Mendez",
      },
      {
        id: 3,
        name: "Rita Berg",
      },
    ],
    devices: [
      {
        id: 0,
        name: "Alba Cardenas",
      },
      {
        id: 1,
        name: "Valeria Davenport",
      },
      {
        id: 2,
        name: "Williams Knowles",
      },
    ],
    onlineDevices: [
      {
        id: 0,
        name: "Roxanne Finch",
      },
    ],
  },
  {
    id: 4,
    name: "Aline Rasmussen",
    address: "559 Bulwer Place, Sattley, Delaware, 2344",
    floors: [
      {
        id: 0,
        name: "Cleo Salinas",
      },
    ],
    offices: [
      {
        id: 0,
        name: "Heidi Black",
      },
      {
        id: 1,
        name: "Burke Blanchard",
      },
    ],
    rooms: [
      {
        id: 0,
        name: "Garza Gaines",
      },
    ],
    devices: [
      {
        id: 0,
        name: "Alexandra Vincent",
      },
    ],
    onlineDevices: [
      {
        id: 0,
        name: "Austin Durham",
      },
    ],
  },
  {
    id: 5,
    name: "Corine Berry",
    address: "466 Amboy Street, Woodburn, Alaska, 4113",
    floors: [
      {
        id: 0,
        name: "Kristi Bennett",
      },
    ],
    offices: [
      {
        id: 0,
        name: "Daniels Rocha",
      },
      {
        id: 1,
        name: "Wade Wheeler",
      },
    ],
    rooms: [
      {
        id: 0,
        name: "Joyce Shelton",
      },
      {
        id: 1,
        name: "Chandler Leach",
      },
      {
        id: 2,
        name: "Lou Stanton",
      },
    ],
    devices: [
      {
        id: 0,
        name: "Moody Chaney",
      },
      {
        id: 1,
        name: "Buchanan Craft",
      },
    ],
    onlineDevices: [
      {
        id: 0,
        name: "Lorraine Perry",
      },
    ],
  },
];
